<template>
  <avs-button
    v-bind="{ ...$attrs }"
    v-on="{ ...$listeners }"
    color="primary"
    iconI="mdi-check-circle"
    noSpantext
  >
    <template v-slot:name>{{ $t("commons.validate") }}</template>
  </avs-button>
</template>

<script>
export default {
  name: "ValidateButton",
  props: {},
  methods: {}
}
</script>
